import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';

function FaqShopeeRichText(props: BaseMsgProps) {
  const { shopeeRichTextContent } = props.raw;

  if (!shopeeRichTextContent) {
    return <></>;
  }

  return (
    <MessageExtendComplex
      {...props}
      content={<Container dangerouslySetInnerHTML={{ __html: shopeeRichTextContent.text }} />}
    />
  );
}

const Container = styled.div`
  max-width: 450px;
  padding: 8px 12px;
  border-radius: 4px;
  background: #fff;
  > p {
    margin-bottom: 0;
  }
`;

export default FaqShopeeRichText;
